import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="homepage"
export default class extends Controller {
  connect() {
    this.smoothScrollListeners = []
    this.initializeSmoothScroll()
    this.initializeFeatureCardAnimations()
  }

  disconnect() {
    // Clean up smooth scroll listeners
    this.smoothScrollListeners.forEach(({ element, handler }) => {
      element.removeEventListener('click', handler)
    })
    this.smoothScrollListeners = []

    // Clean up intersection observer
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  initializeSmoothScroll() {
    // Handle smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      const handler = (e) => {
        e.preventDefault()
        const target = document.querySelector(anchor.getAttribute('href'))
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      }
      anchor.addEventListener('click', handler)
      this.smoothScrollListeners.push({ element: anchor, handler })
    })
  }

  initializeFeatureCardAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeInUp 0.6s ease forwards'
          entry.target.style.animationDelay = `${entry.target.dataset.delay || 0}s`
        }
      })
    }, observerOptions)

    // Observe feature cards
    document.querySelectorAll('.feature-card').forEach((card, index) => {
      card.dataset.delay = (index * 0.1).toFixed(1)
      card.style.opacity = '0'
      this.observer.observe(card)
    })
  }

  scrollToWaitlist(event) {
    event.preventDefault()
    const waitlistSection = document.getElementById('waitlist')
    if (waitlistSection) {
      waitlistSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }
}
